import React from "react";

import { useEffect, useState } from "react";

import PricingShadowWrapper from "../../common/PricingShadowWrapper";

import {
  Container,
  CircularProgress,
  Button,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@mui/material';

import { PLANS, paymentProcessor } from "../../planConfig";

import {db} from '../../firebaseConfig';

import { getAuth, onAuthStateChanged } from "firebase/auth";

import { doc, getDoc } from "firebase/firestore";

import { createStripeCustomerPortalSession, createDodoPaymentsCustomerPortalSession, createPaddleCustomerPortalSession } from "../../common/FunctionCalls";

import lockImage from "../../images/website-images/lock.png"


//OLD Stuff
const plans = PLANS;

function getPlanPriceIntegerPart(planName,frequency) {
	   
    let formattedPrice = "";

    if (planName != null)
    {
          const price = plans[frequency][planName].price;
       
          formattedPrice = "$"+Math.trunc(price);
    }

    return formattedPrice;
 }

 function getPlanPriceDecimalPart(planName,frequency) {
	   
    let formattedPrice = "";

    if (planName != null)
    {
          const price = plans[frequency][planName].price;
       
          if (Number.isInteger(price)) {
            formattedPrice = "00";
          }
        
          const decimalStr = price.toString().split('.')[1];
          formattedPrice = Number(decimalStr);
    }

    return formattedPrice;
 }
  

// And logOutUser function:
const logOutUser = () => {
  console.log("User logged out");
  window.location.href = "/logout";
};

const user = {
    planType:"standard", 
    planName:"Standard"
};



//**************************************************/


const ShadowPageContent = () => {

  const [isAnnual, setIsAnnual] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedFrequency, setSelectedFrequency] = useState('monthly');
  
  const [stripeCustomerId, setStripeCustomerId] = useState('');
  const [dodoCustomerId, setDodoCustomerId] = useState('');

  const [paddleCustomerId, setPaddleCustomerId] = useState('');
  const [paddleSubscriptionId, setPaddleSubscriptionId] = useState('');

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [accountStatus, setAccountStatus] = useState("");
  const [accountSubscriptionType, setAccountSubscriptionType] = useState("");
  const [accountSubscriptionPlan, setAccountSubscriptionPlan] = useState("");
  const [accountSubscriptionFrequency, setAccountSubscriptionFrequency] = useState("");

  const [loadingPlanId, setLoadingPlanId] = useState(null);

  const [loading, setLoading] = useState(true);

  const [userRole, setUserRole] = useState('');

  const [openAdminOnlyDialog, setOpenAdminOnlyDialog] = useState(false);

  //const navigate = useNavigate();

    const [companyToggleDisplay, setCompanyToggleDisplay] = useState("none");
  const [companyToggleDisplayMobile, setCompanyToggleDisplayMobile] = useState("none");

  const [resourceToggleDisplay, setResourceToggleDisplay] = useState("none");
  const [resourceToggleDisplayMobile, setResourceToggleDisplayMobile] = useState("none");

  const [supportToggleDisplay, setSupportToggleDisplay] = useState("none");
  const [supportToggleDisplayMobile, setSupportToggleDisplayMobile] = useState("none");

  const [menuIsActive, setMenuIsActive] = useState(false);
  const [toggleButtonColor, setToggleButtonColor] = useState("gray");

  const handleFrequencyChange = (event) => {

        const newValue = !isAnnual;

        setIsAnnual(!isAnnual);

        if (newValue)
        {
            setFrequency("yearly"); 
            setToggleButtonColor("#2196F3");
        }else
        {
            setFrequency("monthly");
            setToggleButtonColor("gray");
        }

    }


  const toggleMobileHamburgerMenu = () => {
    setMenuIsActive(prev => !prev);
  };

  const toggleTopMenusOff= () => {

    setCompanyToggleDisplay("none");
    setResourceToggleDisplay("none");
    setSupportToggleDisplay("none");
    
  }

  const toggleCompany = () => {

    setResourceToggleDisplay("none");
    setSupportToggleDisplay("none");

    if (companyToggleDisplay === "none")
    {
        setCompanyToggleDisplay("block");

    }else if (companyToggleDisplay === "block")
    {
        setCompanyToggleDisplay("none");
    }
  }

  
  const toggleCompanyMobile = () => {

    setResourceToggleDisplayMobile("none");
    setSupportToggleDisplayMobile("none");

    if (companyToggleDisplayMobile === "none")
    {
        setCompanyToggleDisplayMobile("block");

    }else if (companyToggleDisplayMobile === "block")
    {
        setCompanyToggleDisplayMobile("none");
    }
  }



  const toggleResource = () => {

    setCompanyToggleDisplay("none");
    setSupportToggleDisplay("none");

    if (resourceToggleDisplay === "none")
    {
        setResourceToggleDisplay("block");

    }else if (resourceToggleDisplay === "block")
    {
        setResourceToggleDisplay("none");
    }
  }

  
  const toggleResourceMobile = () => {

    setCompanyToggleDisplayMobile("none");
    setSupportToggleDisplayMobile("none");

    if (resourceToggleDisplayMobile === "none")
    {
        setResourceToggleDisplayMobile("block");

    }else if (resourceToggleDisplayMobile === "block")
    {
        setResourceToggleDisplayMobile("none");
    }
  }


  
  const toggleSupport = () => {

    setCompanyToggleDisplay("none");
    setResourceToggleDisplay("none");

    if (supportToggleDisplay === "none")
    {
        setSupportToggleDisplay("block");

    }else if (supportToggleDisplay === "block")
    {
        setSupportToggleDisplay("none");
    }
  }

  
  const toggleSupportMobile = () => {

    setCompanyToggleDisplayMobile("none");
    setResourceToggleDisplayMobile("none");

    if (supportToggleDisplayMobile === "none")
    {
        setSupportToggleDisplayMobile("block");

    }else if (supportToggleDisplayMobile === "block")
    {
        setSupportToggleDisplayMobile("none");
    }
  }


  useEffect(() => {
    const auth = getAuth();
  
    setSelectedPlan('');

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          setIsUserLoggedIn(true);
  
          const uid = user.uid;
          const userDocRef = doc(db, "appUsers", uid);
          const userSnapshot = await getDoc(userDocRef);
  
          if (!userSnapshot.exists()) {
            setLoading(false);
            return;
          }
  
          const userData = userSnapshot.data();
          const accountNumber = userData.accountNumber;
          if (!accountNumber) {
            setLoading(false);
            return;
          }
  
          setUserRole(userData.role);
  
          const accountDocRef = doc(db, "appAccounts", accountNumber);
          const accountSnapshot = await getDoc(accountDocRef);
  
          if (!accountSnapshot.exists()) {
            setLoading(false);
            return;
          }
  
          const accountData = accountSnapshot.data();
  
          setAccountSubscriptionType(accountData.subscriptionType ?? '');
          setAccountSubscriptionPlan(accountData.subscriptionPlan ?? '');
          setAccountSubscriptionFrequency(accountData.subscriptionFrequency ?? '');
          setAccountStatus(accountData.status ?? '');
  
          if (accountData?.stripeCustomerId) {
            setStripeCustomerId(accountData.stripeCustomerId ?? null);
          } else {
            setStripeCustomerId(null);
          }

          if (accountData?.dodoCustomerId) {
            setDodoCustomerId(accountData.dodoCustomerId ?? null);
          } else {
            setDodoCustomerId(null);
          }

          if (accountData?.paddleCustomerId) {
            setPaddleCustomerId(accountData.paddleCustomerId ?? null);
          } else {
            setPaddleCustomerId(null);
          }

          if (accountData?.paddleSubscriptionId) {
            setPaddleSubscriptionId(accountData.paddleSubscriptionId ?? null);
          } else {
            setPaddleSubscriptionId(null);
          }
  
         if (accountData?.subscriptionFrequency === "yearly") {
            setIsAnnual(true);
            setFrequency("yearly"); 
            setToggleButtonColor("#2196F3");
          } else
          {
            setFrequency("monthly");
            setToggleButtonColor("gray");
          }
  
        } catch (error) {
          console.error("Error fetching account info:", error);
        } finally {
          setLoading(false);  // ✅ always stop loading even if error happens
        }
  
      } else {
        // ✅ Only set loading false AFTER the auth check finishes
        setIsUserLoggedIn(false);
        setLoading(false);
      }
    });
  
    return () => unsubscribe();
  }, []);
  

  useEffect(() => {
  
     const frequencyKey = isAnnual ? 'yearly' : 'monthly';
     setSelectedFrequency(frequencyKey);
  
  }, [isAnnual]);

  const handleSubscribe = (planId) => {

    if (isUserLoggedIn && userRole !=="admin")
    {
      setOpenAdminOnlyDialog(true);
      
    } else 
    {
        setSelectedPlan(planId);
        setSelectedFrequency(isAnnual ? 'yearly' : 'monthly');
      //  navigate(`/subscribe?plan=${planId}&frequency=${isAnnual ? 'yearly' : 'monthly'}`);

      window.location.href = `/subscribe?plan=${planId}&frequency=${isAnnual ? 'yearly' : 'monthly'}`;

    }
  };

  const goToCustomerPortal = async (planId) => {

    if (isUserLoggedIn && userRole ==="admin")
    {
              setLoadingPlanId(planId); // start loading spinner on button click

              setSelectedPlan(planId);
              setSelectedFrequency(isAnnual ? 'yearly' : 'monthly');

              //window.location.href = `https://billing.stripe.com/p/login/test_dR63fN3y76cR2Ag000`;

              const auth = getAuth();

              switch (paymentProcessor) {
                    case "stripe":
                        const sessionIdInfo = await createStripeCustomerPortalSession(
                        stripeCustomerId,
                        "/subscriptions",
                        auth
                        );
                        if (sessionIdInfo.url) {
                            window.location.href = sessionIdInfo.url;
                        }
        
                    break;
        
                    case "dodopayments":
                        const sessionIdDodoInfo = await createDodoPaymentsCustomerPortalSession(
                        dodoCustomerId,
                        "/subscriptions",
                        auth
                        );

                        console.log(sessionIdDodoInfo);
                        if (sessionIdDodoInfo.url) {
                            //window.location.href = sessionIdDodoInfo.url;
                            window.open(sessionIdDodoInfo.url, "_blank", "noopener,noreferrer");
                        }
                    break;

                    case "paddle":
                        const paddleSessionIdInfo = await createPaddleCustomerPortalSession(
                        paddleCustomerId,
                        paddleSubscriptionId,
                        auth
                    );
                    if (paddleSessionIdInfo.url) {
                        window.open(paddleSessionIdInfo.url, '_blank', "noopener,noreferrer");
                    }
                    break;
        
                    default:
                }
        


      } else 
      {
        setOpenAdminOnlyDialog(true);
      }
  };

  const frequencyKey = isAnnual ? 'yearly' : 'monthly';

  const dynamicPlans = Object.entries(PLANS.planAdditionaInfo).map(([key, info]) => {
    return {
      id: key,
      title: info.title,
      features: info.features,
      popular: info.popular || false,
      price: PLANS[frequencyKey][key]?.price ?? 0
    };
  });
    
// OLD STUFF

const [frequency, setFrequency] = useState("monthly");

  return (
    <html lang="en">
    <head>
        <meta charset="UTF-8"/>
        <title>Pricing | GoTailo</title>
        <meta name="description" content="Compare GoTailo plans and choose the best for you. We have plans for everyone." />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width,initial-scale=1.0" />
     
        <meta property="og:url" content="https://gotailo.com/pricing.html" />
        <meta property="og:type" content="" />
        <meta property="og:title" content="Pricing | GoTailo" />
        <meta property="og:description" content="Compare GoTailo plans and choose the best for you. We have plans for everyone." />
        <meta property="og:image" content="" />
        <meta name="twitter:image" content="" />
        <link rel="canonical" href="https://gotailo.com/pricing.html" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        {/* <link rel="stylesheet" type="text/css" href="css/style.css" /> */}

        <script src="js/jquery-3.5.1.min.js"></script>
        <script type="text/javascript" src="js/sites-scripts.js"></script>
      
        {/*
      <link rel="stylesheet" type="text/css" href="css/page-specific/pricing.css" />
    */}
 
      </head>

      <body class="bodyStyle">
{loading ? (
      <div
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white", // optional, or set to 'transparent'
    zIndex: 9999, // optional
  }}
>
  <div
    style={{
      width: "180px",
      height: "24px",
      border: "3px solid #595f66",
      borderTop: "3px solid #3498db",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
      display: "inline-block",
    }}
  />
</div>

      ) : (
        <div class="pricePagecontent ">
        
            <div class="pricePagegr-encloser-cookie " id="cookie-policy-banner">
        
                <div class="pricePagegr-cookie-container ">
                    <div class="pricePagegr-cookie-enclosure ">
                        <div class="pricePagegr-cookie-head pricePagegr-space-fix ">
                            <div class="pricePagegr-cookie-title ">
                                This Site Uses Cookies
                            </div>
                            <div class="pricePagegr-cookie-permission " id="cookieAllow" onclick="cookieAccept();">
                                Allow
                            </div>
                        </div>
                        <div class="pricePagegr-cookie-content ">
                            <div>
                                We use cookies to enhance site navigation, analyze site usage, and assist us to improve your website experience as set out in our <a href="/cookie-policy.html">Cookie Policy</a>.
                            </div>
                                                                        </div>
                                                                                </div>
                </div>
            </div>
           
            {/* START Header */}

            <header class="pricePageheader" id="theHeader">

            <div class="pricePagerow pricePagegr-mobile-top-menu-encloser ">
            <div id="mobilePrimaryMenu">
                <div class="pricePagenavbar-header ">
                    <div class="pricePagegr-mobile-menu-wrap pricePagegr-space-fix ">
                        <div class="pricePagegr-mobile-menu-left-side pricePagegr-space-fix ">
                            <div class="pricePagegr-hamburger-button " onClick={toggleMobileHamburgerMenu}>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div class="pricePagegr-mobile-menu-logo-container ">
                                <a href="/" title="">
                                    <img class="pricePagelogo pricePagescrollView " src='https://gotailo.com/images/logo.png' alt="logo" />
                                </a>
                            </div>
                        </div>
                        <div class="pricePagegr-mobile-menu-right-side pricePagegr-space-fix ">
                            <div class="pricePagegr-tablet-tick-contact-container ">
                                <a class="pricePagebtn pricePagenormal pricePagegr-gtitem-blue " href="/login">
                                                                             LOGIN
                                </a>
                            </div>
                            
                            {!isUserLoggedIn && 
                            <div class="pricePagegr-mobile-menu-signup-container ">
                                <a class="pricePagebtn pricePagenormal pricePagegreen " href="/pricing">
                                    SIGN UP for FREE
                                </a>
                            </div>
                            }

                            {isUserLoggedIn && 
                            <div class="pricePagegr-mobile-menu-signup-container ">
                                <div class="pricePagebtn pricePagenormal pricePagegreen " onClick={logOutUser}>
                                    LOGOUT
                                </div>
                            </div>
                            }
                            
                            <div class="pricePagegr-mobile-menu-login-container ">
                                <a href="/login">
                                    <img class="pricePagegr-menu-login-icon " src="images/login-icon-blue.png" alt="Login" border="0" />
                                </a>
                            </div>
                            <div class="pricePagegr-tablet-tick-button-container ">
                                <a href="/signup">
                                    <img class="pricePagegr-menu-login-icon " src="images/search-icon-blue.png" alt="Login" border="0" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="pricePagegr-tablet-special-search " id="tabletChannelSearch">
                        <div class="pricePagegr-tablet-tick-field-enclosure " id="channel-search">

                        </div>
                    </div>
                </div>
                <div className={`pricePagenavbar-collapse pricePageignore-additional-spaces pricePagegr-mobile-secondary-menu ${menuIsActive ? ' active' : ''}`}>
                    <ul class="pricePagenav pricePagenavbar-nav ">
       
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li class="pricePagedropDown " id="COMPANY">
                            <a data-path="COMPANY" class="pricePagemenuNoLink pricePagedropdown-toggle"  onClick={toggleCompanyMobile} onMouseEnter={toggleCompanyMobile} style={{ cursor: 'pointer' }}>
                                COMPANY         
                            </a>
                            <ul class="pricePagedropDownMobile" style={{display:companyToggleDisplayMobile}}>
                                <li>
                                    <a href="/about.html" class="">
                                        About Us
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        {/*
                        <li class="">
                            <a href="/pricing" class="pricePagemenuNoLink pricePagedropdown-toggle ">
                                PRICING
                            </a>
                        </li>
                        */}

                        
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li>
                            <a href="/blog">
                            Blog
                            </a>
                        </li>

                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                            
                        <li class="pricePagedropDown " id="Resources">
                            <a data-path="Resources" class="pricePagemenuNoLink pricePagedropdown-toggle"  onClick={toggleResourceMobile} onMouseEnter={toggleResourceMobile} style={{ cursor: 'pointer' }}>
                                Resources
                            </a>
                            <ul class="pricePagedropDownMobile" style={{display:resourceToggleDisplayMobile}}>
                                <li>
                                    <a href="/faq.html" class="">
                                        FAQ
                                    </a>
                                </li>

                            </ul>
                        </li>
                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                        <li class="pricePagedropDown " id="Support">
                            <a data-path="Support" class="pricePagemenuNoLink pricePagedropdown-toggle"  onClick={toggleSupportMobile} onMouseEnter={toggleSupportMobile} style={{ cursor: 'pointer' }}>
                                Support
                            </a>
                            <ul class="pricePagedropDownMobile" style={{display:supportToggleDisplayMobile}}>
                                <li>
                                    <a href="/faq.html" >
                                        FAQ
                                    </a>
                                </li>
                       
                                <li>
                                    <a href="/contactus" >
                                        Contact Us
                                    </a>
                                </li>
                                <li>
                                    <a href="/login" >
                                        Login
                                    </a>
                                </li>
                                
                            </ul>
                        </li>

                        <li>
                            <span class="pricePageseparator "></span>
                        </li>
                
                    </ul>
                    <div class="pricePagegr-mobile-point-buttonsWrap ">
                        <div class="pricePagegr-mobile-point-buttonsBox ">
                            <div class="pricePagegr-mobile-point-buttons">
                                <a class="pricePagebtn pricePagenormal pricePagegr-gtitem-blue " href="/login">
                                                                                LOGIN
                                                                        </a>
                                                                    <a class="pricePagebtn pricePagenormal pricePagegreen " href="/signup">
                                    SIGN UP for FREE
                                </a>
                                                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pricePagerow pricePagegr-desktop-main-menu-wrap ">
            <div class="pricePagecontainer pricePageignore-additional-spaces pricePagegr-desktop-main-menu-container pricePagegr-space-fix ">
                <div class="pricePagegr-desktop-menu pricePageignore-additional-spaces ">
                    <div id="primaryMenu" class="pricePagenavbar " style={{minWidth:'100%',padding:'0px',margin:'0px'}}>
                        <ul class="pricePagenav pricePagenavbar-nav pricePagenav-pills pricePagegr-space-fix " style={{minWidth:'100%'}}>
                            <table style={{width:'100%'}}>
                                <tr>
                                    <td style={{float:'left'}}>
                                        <ul class="pricePagegr-main-menu-wrap pricePagegr-space-fix ">
                                        <li class="pricePagedesktopLogo pricePageignore-additional-spaces ">
                                            <a href="/" title="" onMouseEnter={toggleTopMenusOff}>
                                                <img class="pricePagelogo pricePagegr-normal-view " src='https://gotailo.com/images/logo.png' alt="logo" />
                                                <img class="pricePagelogo pricePagegr-scroll-view " src='https://gotailo.com/images/logo.png' alt="logo" />
                                            </a>
                                        </li>
                                        <li class="pricePagedropDown pricePagecompany ">
                                            
                                            <a class="menuNoLink pricePagedropdown-toggleX " data-hover="dropDown" data-toggle="dropDown" onClick={toggleCompany} onMouseEnter={toggleCompany} style={{ cursor: 'pointer' }}>
                                                COMPANY
                                            </a>
                                         
                                            <ul class="pricePagemenu-dropdown pricePagecol2" style={{display:companyToggleDisplay}}>
                                                <li class="pricePagegr-space-fix pricePagegr-menu-nav-enclosure ">
                                                    <ul class="pricePagecol1 pricePagecolAll ">
                                                        <li class="pricePagegr-middle-list pricePagegr-space-fix ">
                                                            <ul class="pricePagegr-menu-left-side ">
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/about.html" class="">
                                                                        About Us
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        {/*
                                        <li class="pricePagegr-single-link pricePagepricing ">
                                            <a href="/pricing/" class="">
                                                PRICING
                                            </a>
                                        </li>
                                        */}
                                        </ul>
                                    </td>

                                    <td style={{float:'right'}}>
                                        <ul class="pricePagegr-main-menu-wrap pricePagegr-space-fix ">
                                        <li class="pricePagedropDown pricePageresources pricePagerightRefferer ">
                                            <a class="pricePagemenuNoLink pricePagedropdown-toggleX " data-hover="dropDown" data-toggle="dropDown"  onClick={toggleResource} onMouseEnter={toggleResource} style={{ cursor: 'pointer' }}>
                                                Resources
                                            </a>
                                            <ul class="pricePagemenu-dropdown pricePagegr-wrap-col2 pricePagegr-space-fix"  style={{display:resourceToggleDisplay}}>
                                                <li class="pricePagegr-wrap-col-left ">
                                                    <ul>
                                                        <li>
                                                            <ul class="pricePagecol1 pricePagecolAll ">
                                                                <li class="pricePagegr-middle-list pricePagegr-space-fix ">
                                                                    <ul class="pricePagemenugr-left-side ">
                                                                        <li class="pricePagelevel2 ">
                                                                            <a href="/faq.html" class="">
                                                                                FAQ
                                                                            </a>
                                                                        </li>
                                                               
                                                                    </ul>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="pricePagedropDown pricePagesupport pricePagerightRefferer "  onClick={toggleSupport} onMouseEnter={toggleSupport} style={{ cursor: 'pointer' }}>
                                            <a class="pricePagemenuNoLink ">
                                                Support
                                            </a>
                                            <ul class="pricePagemenu-dropdown pricePagecol2 " style={{display:supportToggleDisplay}}>
                                                <li class="pricePagegr-space-fix pricePagegr-menu-nav-enclosure ">
                                                    <ul class="pricePagecol1 pricePagecolAll ">
                                                        <li class="pricePagegr-middle-list pricePagegr-space-fix ">
                                                            <ul class="pricePagegr-menu-left-side ">
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/faq.html" >
                                                                        FAQ
                                                                    </a>
                                                                </li>
                                                     
                                                     
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/blog" >
                                                                        Blog
                                                                    </a>
                                                                </li>

                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/contactus" >
                                                                        Contact Us
                                                                    </a>
                                                                </li>
                                                                <li class="pricePagelevel2 ">
                                                                    <a href="/login" >
                                                                        Login
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        
                                        <li class="pricePagegr-desktop-login pricePagegr-desktop-login-blue " onMouseEnter={toggleTopMenusOff}>
                                            <a href="/login">
                                                <img class="pricePagegr-menu-login-icon " src='https://gotailo.com/images/login-icon-blue.png' alt="Login" border="0"/>
                                                <span class="pricePagegr-menu-login-text ">
                                                                Login
                                                            </span>
                                            </a>
                                        </li>
                                        <li class="pricePagegr-desktop-login pricePagedesktopLoginWhite " onMouseEnter={toggleTopMenusOff}>
                                            <a href="/login">
                                                <img class="pricePagegr-menu-login-icon " src='https://gotailo.com/images/login-icon-white.png' alt="Login" border="0"/>
                                                <span class="pricePagegr-menu-login-text ">
                                                                Login
                                                            </span>
                                            </a>
                                        </li>

                                        <li class="pricePagegr-contact-more-info pricePagegr-contact-more-info-blue " onMouseEnter={toggleTopMenusOff}>
                                            
                                            <a class="pricePagebtn pricePagegr-gtitem-blue " href="/login">
                                                LOGIN
                                            </a>
                                            
                                        </li>
                                        {isUserLoggedIn && 
                                        
                                        <li class="pricePagegr-contact-more-info pricePagegr-contact-more-info-blue " onMouseEnter={toggleTopMenusOff}>
                                            
                                            <a class="pricePagebtn pricePagegr-gtitem-blue "  onClick={logOutUser}>
                                                LOGOUT
                                            </a>
                                            
                                        </li>
                                        }

                                        <li class="pricePagegr-contact-more-info pricePagegr-contact-more-info-white " onMouseEnter={toggleTopMenusOff}>
                                                <a class="pricePagebtn pricePagegr-gtitem-white " href="/login">
                                                LOGIN
                                                </a>
                                        </li>

                                        {isUserLoggedIn && 
                                        <li class="pricePagegr-contact-more-info pricePagegr-contact-more-info-white " onMouseEnter={toggleTopMenusOff}>
                                                <a class="pricePagebtn pricePagegr-gtitem-white " onClick={logOutUser}>
                                                LOGOUT
                                                </a>
                                        </li>
                                        }

                                        <li class="pricePagegr-signup-nomoney-menu " onMouseEnter={toggleTopMenusOff}>
                                            <a class="pricePagebtn pricePagegreen " href="/signup">
                                                SIGN UP for FREE
                                            </a>
                                        </li>
                                        </ul>
                                    </td>
                                </tr>
                            </table>
    
                        </ul>
                    
                    </div>
                    
                    <div class="pricePagegr-desktop-search " id="desktopChannelSearch">
                        <div class="pricePagegr-desktop-search-item-enclosure " id="channel-search">

                        </div>
                    </div>
                </div>
            </div>
        </div>
        </header>
            <div class="pricePagegr-space-fix "></div>
            {/* End Header */}
            {/*  Start Content  */}
            <div class="pricePagegr-enclose-all ">
                <div class="pricePagepricing ">

                <div class="pricePagegr-entry-page-rectangle-container pricePagegr-the-low-menu ">
        <div class="pricePagegr-entry-page-rectangle-wrap ">
        <div class="pricePagecontainer pricePageignore-additional-spaces ">
            <div class="pricePagegr-first-info-special-wrapper pricePagegr-space-fix ">
            <h1 class="pricePageintroPageBannerTitle pricePagegr-color-white pricePagetext-center ">
            Plans and Prices
            </h1>
            {!loading && (!isUserLoggedIn || (isUserLoggedIn && userRole === "admin")) &&     
            <>
           
            <h4 class="pricePagegr-section-title2 pricePagetext-center pricePagewhite " style={{fontSize:'24px'}}>
                Compare Plans and Choose the Best Solution for You.<br/>
                No Contracts. No Commitment. Cancel anytime.
            </h4>
            </>
            }


 {loading ? (
      <Container maxWidth="sm" sx={{ mt: 10, textAlign: 'center' }}>
        
        <CircularProgress size={180}/>
      </Container>
      ) : (
      <>
        {isUserLoggedIn && userRole !== "admin" ? (

               <div
                style={{
                    maxWidth: '600px',
                    margin: '100px auto',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#f5f5f5',
                    padding: '40px',
                    position: 'relative',
                    textAlign: 'center',
                    minHeight: '300px',
                    fontFamily: 'Arial, sans-serif',
                }}
                >
                {/* Watermark lock image */}
                <img
                    src={lockImage}
                    alt="lock"
                    style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    width: '100px',
                    height: '100px',
                    transform: 'translate(-50%, -50%)',
                    pointerEvents: 'none',
                    }}
                />

                <h2 style={{ marginBottom: '20px' }}>Subscription Access Restricted</h2>

                <p style={{ color: '#666', fontSize: '16px' }}>
                    Subscription and plan information can only be managed by admin users. Please contact your
                    administrator if you have questions.
                </p>
                </div>

        ) : (
        
            <div style={{paddingTop:'30px'}}>
                <center>
                <table>
                    <tr>
                    <td style={{color:'#ffffff',paddingLeft:'10px',paddingRight:'10px'}}><div style={{marginTop:'15px'}}>Pay yearly and save up to {PLANS.annualSavingPercentage}%</div></td>
                    <td>

                        <input
                            className="react-switch-checkbox"
                            id={`react-switch-new`}
                            type="checkbox" 
                            onChange={handleFrequencyChange}
                        />
                        <label
                            className="react-switch-label" 
                            style={{backgroundColor:toggleButtonColor}}
                            htmlFor={`react-switch-new`}
                        >
                            <span className={`react-switch-button`} />
                        </label>

                    </td>
                    </tr> 
                </table>
                </center>
            </div>

    )}
        </>
      )}     

                        </div>
        </div>
        </div>

        </div>

{!loading && (!isUserLoggedIn || (isUserLoggedIn && userRole === "admin")) &&
    <div id="mainPriceContent" onMouseEnter={toggleTopMenusOff}>
        {/* START Section1  */}
        <div class="pricePagegr-encloser-gray pricePagegr-encloser-container pricePagesection1 ">
        <div class="pricePagecontainerPrice pricePageignore-additional-spaces ">
        <div class="pricePagerow pricePageignore-additional-spaces ">
            <div class="pricePagegr-enclose-pricing-container ">
            <div class="pricePagegr-pricing-sub-menu pricePagegr-space-fix ">
                <div class="pricePagegr-most-popular-wrap ">

                {/* First Plan  */}
                <div class="pricePagegr-pricing-sub-menu-item1 pricePagegr-pricing-sub-menuItemAll pricePagegr-tile-price-top-space ">
                    <div class="pricePagegr-most-popular-wrap pricePagegr-encloser-white pricePagegr-bottom-border-blue ">
                    <h5 class="pricePagegr-most-popular pricePagegr-encloser-blue pricePagewhite pricePagegr-spaces-0 pricePagefont400 " style={{fontSize:'20px'}}>
                        {PLANS.planAdditionaInfo['lite'].title}
                    </h5>
                    <div class="pricePagegr-enclose-top-item ">
                        <div classX="pricePagetext-center pricePagegr-desktop-min-height "  style={{fontSize:'17px', ...(window.innerWidth > 768 && { minHeight: '130px' })}}>
                       {PLANS.planAdditionaInfo['lite'].description}
                        </div>
                        <h4 class="pricePagecolorBlueX pricePagefont500 pricePagetext-center pricePagegr-bottom-spaces-0 pricePagegr-price-amount-top-space ">
                        
                        <center>
                            <table>
                                <tr>
                                <td style={{fontSize:'45px',fontWeight:'bold'}}>{getPlanPriceIntegerPart('lite',frequency)}</td>
                                <td style={{padding:'0px',margin:'0px',paddingLeft:'5px'}}>
                                <div style={{paddingBottom:'-5px',marginBottom:'-5px',fontSize:'16px',fontWeight:'bold'}}>.{getPlanPriceDecimalPart('lite',frequency)}</div> <div style={{paddingBottom:'-15px',marginBottom:'-15px',fontSize:'16px'}}>monthly</div>
                                </td>
                                </tr>
                            </table>
                           
                        </center>

                        </h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px'}}>
                        Cancel Anytime
                        {frequency != "monthly" &&  
                              <div style={{fontWeight:'plain',fontSize:'14px',color:'blue'}}>
                                Billed {frequency}
                                </div>
                            }
                        </div>
                        
                        {!isUserLoggedIn && 
                                    
                        <div class="pricePagegr-signup-button pricePagetext-center ">
                            <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/signup"} style={{textDecoration:'none'}}><span>Try it for FREE</span></a>
                        </div>
                        
                        }


                        {isUserLoggedIn && 
                            <span>
                            {(accountSubscriptionType === "trial" || (accountSubscriptionType !== "trial" && accountSubscriptionPlan !== "lite")) && 
                             <>
                                {accountStatus !== 'canceled' && 
                                <div>
                                 
                                    {accountSubscriptionType === "trial" &&
                                    <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " onClick={(e) => {e.preventDefault(); handleSubscribe("lite"); }}><span>Subscribe to {PLANS.planAdditionaInfo['lite'].title}</span></a>
                                    }
                                    {(accountSubscriptionType !== "trial" && accountSubscriptionPlan !== "lite") && 
                                   <>
                                     {loadingPlanId === "lite" ? (
                                          <div
                                            style={{
                                            width: "24px",
                                            height: "24px",
                                            border: "3px solid #f3f3f3",
                                            borderTop: "3px solid #3498db",
                                            borderRadius: "50%",
                                            animation: "spin 1s linear infinite",
                                            display: "inline-block"
                                            }}
                                        />
                                        ) : (
                                          <a
                                            className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                            onClick={() => goToCustomerPortal("lite")}
                                            style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                            >
                                            <span>Switch to {PLANS.planAdditionaInfo["lite"].title}</span>
                                           </a>
                                        )}
                                    </>
                                    }   

                                </div>

                                }

                                {accountStatus === 'canceled' &&
                                <div>
                                   <>
                                     {loadingPlanId === "lite" ? (
                                          <div
                                            style={{
                                            width: "24px",
                                            height: "24px",
                                            border: "3px solid #f3f3f3",
                                            borderTop: "3px solid #3498db",
                                            borderRadius: "50%",
                                            animation: "spin 1s linear infinite",
                                            display: "inline-block"
                                            }}
                                        />
                                        ) : (
                                          <a
                                            className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                            onClick={() => goToCustomerPortal("lite")}
                                            style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                            >
                                            <span>Renew to {PLANS.planAdditionaInfo['lite'].title}</span>
                                           </a>
                                        )}
                                    </>
                                </div>
                                }

                                </>
                            }
                            {accountSubscriptionType !== "trial" && accountSubscriptionPlan === "lite" && 
                                <>
                                  {accountStatus !== 'canceled' &&
                                  <>
                                        <div style={{fontWeight:'bold', color:'blue',fontSize:'20px'}}>
                                            Your Current Plan
                                        </div>

                                        {accountSubscriptionFrequency !== selectedFrequency &&
                                        <div>
                                        
                                            {loadingPlanId === "lite" ? (
                                                <div
                                                    style={{
                                                    width: "24px",
                                                    height: "24px",
                                                    border: "3px solid #f3f3f3",
                                                    borderTop: "3px solid #3498db",
                                                    borderRadius: "50%",
                                                    animation: "spin 1s linear infinite",
                                                    display: "inline-block"
                                                    }}
                                                />
                                                ) : (
                                                <a
                                                    className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                    onClick={() => goToCustomerPortal("lite")}
                                                    style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                    >
                                                    <span>Switch to {accountSubscriptionFrequency=== "monthly" ? "Yearly" : "Monthly"}</span>
                                                </a>
                                                )}
                                            </div>
                                            }
                                    </>
                                    }

                                    {accountStatus === 'canceled' && 
      
                                                <>
                                                    {loadingPlanId === "lite" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("lite")}
                                                        style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Renew to {PLANS.planAdditionaInfo['lite'].title}</span>
                                                    </a>
                                                    )}
                                                </>
      
                                   }
                                
                                
                                
                                </>    
                            }

                            </span>
                        }

                        {!isUserLoggedIn && 
                        
                            <div class="pricePagegr-no-credit-card pricePagetext-center ">
                            or <a href="#" onClick={(e) => {e.preventDefault(); handleSubscribe("lite"); }} style={{ fontSize: "17px", fontWeight: "bold", textDecoration: "underline", color: "blue", cursor: "pointer" }}>
                            Subscribe
                            </a>
                            <br/>
                            <div style={{paddingTop:'5px'}}>
                            7 day free trial<br></br>    
                            No credit card required.
                            </div>
    
                            </div>
                        }
                    </div>
                    <div class="pricePagepartnerTestWrap ">
                        <h6 class="pricePagefont300 pricePagegr-bottom-spaces-0 pricePagegr-top-spaces20 " style={{fontSize:'19px'}}>
                        What You Get
                        </h6>
                        <ul class="pricePagegr-spaces-0 ">      
                        <li key={0} className="pricePageblueCheck" style={{fontSize:'17px'}}>
                            Up to <b>{plans.planAdditionaInfo['lite'].maxUserAccounts}</b> {plans.planAdditionaInfo['lite'].maxUserAccounts === 1 ? "seat" : "seats"}
                          </li>            
                        {plans.planAdditionaInfo['lite'].features.map((feature, index) => (
                          <li key={index} className="pricePageblueCheck" style={{fontSize:'17px'}}>
                            {feature}
                          </li>
                        ))}
                        
                        </ul>
                    </div>
                    </div>
                </div>

                {/* Second Plan  */}
                <div class="pricePagegr-pricing-sub-menu-item2 pricePagegr-pricing-sub-menuItemAll ">
                    <div class="pricePagegr-most-popular-wrap pricePagegr-encloser-white pricePagegr-bottom-border-green ">
                    <h5 class="pricePagegr-most-popular pricePagegr-encloser-green pricePagewhite pricePagegr-spaces-0 pricePagefont400" style={{fontSize:'21px',paddingBottom:'0px', marginBottom:'0px'}}>
                        {PLANS.planAdditionaInfo['standard'].title}
                    </h5>
                    <div class="pricePagegr-enclose-top-item " style={{paddingTop:'0px', marginTop:'0px'}}>
                        <h5 class="pricePagefont500 pricePagetext-center " style={{fontSize:'18px', paddingBottom:'0px', marginBottom:'0px', paddingTop:'0px', marginTop:'0px'}}>
                        <b>Most Popular</b>
                        </h5>
                       <div classX="pricePagetext-center " style={{fontSize:'17px', paddingTop:'10px', marginTop:'0px',...(window.innerWidth > 768 && { minHeight: '110px' })}}>
                        {PLANS.planAdditionaInfo['standard'].description}
                        </div>
                        <h4 class="pricePagecolorGreenX pricePagefont500 pricePagetext-center pricePagegr-bottom-spaces-0 pricePagegr-price-amount-top-space ">
 
                        <center>
                            <table>
                                <tr>
                                <td style={{fontSize:'45px',fontWeight:'bold'}}>{getPlanPriceIntegerPart('standard',frequency)}</td>
                                <td style={{padding:'0px',margin:'0px',paddingLeft:'5px'}}>
                                <div style={{paddingBottom:'-5px',marginBottom:'-5px',fontSize:'16px',fontWeight:'bold'}}>.{getPlanPriceDecimalPart('standard',frequency)}</div> <div style={{paddingBottom:'-15px',marginBottom:'-15px',fontSize:'16px'}}>monthly</div>
                                </td>
                                </tr>
                            </table>
                        </center>
                        </h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px'}}>
                        Cancel Anytime
                        {frequency != "monthly" &&  
                              <div style={{fontWeight:'plain',fontSize:'14px',color:'blue'}}>
                                Billed {frequency}
                                </div>
                            }
                        </div>
                        {!isUserLoggedIn && 
                                    
                                    <div class="pricePagegr-signup-button pricePagetext-center ">
                                        <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/signup"} style={{textDecoration:'none'}}><span>Try it for FREE</span></a>
                                    </div>
                                    
                                    }
            
            
                                    {isUserLoggedIn && 
                                        <span>
                                        {(accountSubscriptionType === "trial" || (accountSubscriptionType !== "trial" && accountSubscriptionPlan !== "standard")) && 
                                         <>
                                        {accountStatus !== 'canceled' &&
                                            <div>
                                             
                                                {accountSubscriptionType === "trial" &&
                                                <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " onClick={(e) => {e.preventDefault(); handleSubscribe("standard"); }}><span>Subscribe to {PLANS.planAdditionaInfo['standard'].title}</span></a>
                                                }
                                                {(accountSubscriptionType !== "trial" && accountSubscriptionPlan !== "standard") &&
                                                   <>
                                                    {loadingPlanId === "standard" ? (
                                                        <div
                                                            style={{
                                                            width: "24px",
                                                            height: "24px",
                                                            border: "3px solid #f3f3f3",
                                                            borderTop: "3px solid #3498db",
                                                            borderRadius: "50%",
                                                            animation: "spin 1s linear infinite",
                                                            display: "inline-block"
                                                            }}
                                                        />
                                                        ) : (
                                                        <a
                                                            className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                            onClick={() => goToCustomerPortal("standard")}
                                                            style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                            >
                                                            <span>Switch to {PLANS.planAdditionaInfo['standard'].title}</span>
                                                        </a>
                                                        )}
                                                    </>
                                                    
                                                }   
                                            </div>

                                            }

                                        {accountStatus === 'canceled' &&
                                        <div>
                                                <>
                                                {loadingPlanId === "standard" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("standard")}
                                                        style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Renew to {PLANS.planAdditionaInfo['standard'].title}</span>
                                                    </a>
                                                    )}
                                                </>
                                        </div>
                                        }

                                        </>
                                        }
                                        {accountSubscriptionType !== "trial" && accountSubscriptionPlan === "standard" && 
                                          <>
                                            {accountStatus !== 'canceled' &&
                                             <>
                                                <div style={{fontWeight:'bold', color:'blue',fontSize:'20px'}}>
                                                    Your Current Plan
                                                </div>

                                                {accountSubscriptionFrequency !== selectedFrequency &&
                                                <div>
                                                <>
                                                    {loadingPlanId === "standard" ? (
                                                        <div
                                                            style={{
                                                            width: "24px",
                                                            height: "24px",
                                                            border: "3px solid #f3f3f3",
                                                            borderTop: "3px solid #3498db",
                                                            borderRadius: "50%",
                                                            animation: "spin 1s linear infinite",
                                                            display: "inline-block"
                                                            }}
                                                        />
                                                        ) : (
                                                        <a
                                                            className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                            onClick={() => goToCustomerPortal("standard")}
                                                            style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                            >
                                                            <span>Switch to {accountSubscriptionFrequency=== "monthly" ? "Yearly" : "Monthly"}</span>
                                                        </a>
                                                        )}
                                                    </>
                                                </div>
                                                }
                                                </>
                                                }

                                                {accountStatus === 'canceled' && 
      
                                                <>
                                                    {loadingPlanId === "standard" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("standard")}
                                                        style={loadingPlanId === "standard" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Renew to {PLANS.planAdditionaInfo['standard'].title}</span>
                                                    </a>
                                                    )}
                                                </>
      
                                                }
                                             
                                          </>    
                                        }
            
                                        </span>
                                    }
                                    {!isUserLoggedIn && 
                                        
                                        <div class="pricePagegr-no-credit-card pricePagetext-center ">
                                        or <a href="#" onClick={(e) => {e.preventDefault(); handleSubscribe("standard"); }} style={{ fontSize: "17px", fontWeight: "bold", textDecoration: "underline", color: "blue", cursor: "pointer" }}>
                                        Subscribe
                                        </a>
                                        <br/>
                                        <div style={{paddingTop:'5px'}}>
                                        7 day free trial<br></br>    
                                        No credit card required.
                                        </div>
                                        
                                        
                                        </div>
                                    }
                    </div>
                    <div class="pricePagepartnerTestWrap ">
                        <h6 class="pricePagefont300 pricePagegr-bottom-spaces-0 pricePagegr-top-spaces20 " style={{fontSize:'19px'}}>
                        What You Get
                        </h6>
                        <ul class="pricePagegr-spaces-0 ">
                          <li key={0} className="pricePageblueCheck" style={{fontSize:'17px'}}>
                            Up to <b>{plans.planAdditionaInfo['standard'].maxUserAccounts}</b> {plans.planAdditionaInfo['standard'].maxUserAccounts === 1 ? "seat" : "seats"}
                          </li>  
                           {plans.planAdditionaInfo['standard'].features.map((feature, index) => (
                          <li key={index} className="pricePageblueCheck" style={{fontSize:'17px'}}>
                            {feature}
                          </li>
                        ))}
                        </ul>
                    </div>
                    </div>
                </div>
                
                {/* Third Plan  */}
                <div class="pricePagegr-pricing-sub-menu-item3 pricePagegr-pricing-sub-menuItemAll pricePagegr-tile-price-top-space ">
                    <div class="pricePagegr-most-popular-wrap pricePagegr-encloser-white pricePagegr-bottom-border-purple ">
                    <h5 class="pricePagegr-most-popular pricePagegr-encloser-purple pricePagewhite pricePagegr-spaces-0 pricePagefont400 " style={{fontSize:'20px'}}>
                        {PLANS.planAdditionaInfo['advanced'].title}
                    </h5>
                    <div class="pricePagegr-enclose-top-item ">

                       <div classX="pricePagetext-center pricePagegr-desktop-min-height " style={{fontSize:'17px', ...(window.innerWidth > 768 && { minHeight: '130px' })}}>
                        {PLANS.planAdditionaInfo['advanced'].description}
                        </div>
                        <h4 class="pricePagefont500 pricePagetext-center pricePagegr-bottom-spaces-0 pricePagegr-price-amount-top-space ">
                        <center>
                            <table>
                                <tr>
                                <td style={{fontSize:'45px',fontWeight:'bold'}}>{getPlanPriceIntegerPart('advanced',frequency)}</td>
                                <td style={{padding:'0px',margin:'0px',paddingLeft:'5px'}}>
                                <div style={{paddingBottom:'-5px',marginBottom:'-5px',fontSize:'16px',fontWeight:'bold'}}>.{getPlanPriceDecimalPart('advanced',frequency)}</div> <div style={{paddingBottom:'-15px',marginBottom:'-15px',fontSize:'16px'}}>monthly</div>
                                </td>
                                </tr>
                            </table>
                        </center>
                        </h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px'}}>
                        Cancel Anytime
                        {frequency != "monthly" &&  
                              <div style={{fontWeight:'plain',fontSize:'14px',color:'blue'}}>
                                Billed {frequency}
                                </div>
                            }
                        </div>
                        {!isUserLoggedIn && 
                                    
                                    <div class="pricePagegr-signup-button pricePagetext-center ">
                                        <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/signup"} style={{textDecoration:'none'}}><span>Try it for FREE</span></a>
                                    </div>
                                    
                                    }
            
            
                                    {isUserLoggedIn && 
                                        <span>
                                        {(accountSubscriptionType === "trial" || (accountSubscriptionType !== "trial" && accountSubscriptionPlan !== "advanced")) && 
                                         <>
                                        {accountStatus !== 'canceled' &&
                                            <div>
                                             
                                               {accountSubscriptionType === "trial" &&
                                                <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " onClick={(e) => {e.preventDefault(); handleSubscribe("advanced"); }}><span>Subscribe to {PLANS.planAdditionaInfo['advanced'].title}</span></a>
                                                }
                                                {(accountSubscriptionType !== "trial" && accountSubscriptionPlan !== "advanced") &&
                                                <>
                                                {loadingPlanId === "advanced" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("advanced")}
                                                        style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Switch to {PLANS.planAdditionaInfo['advanced'].title}</span>
                                                    </a>
                                                    )}
                                                </>
                                                }   
                                            </div>

                                            }

                                        {accountStatus === 'canceled' &&
                                        <div>
                                            <>
                                                {loadingPlanId === "advanced" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("advanced")}
                                                        style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Renew to {PLANS.planAdditionaInfo['advanced'].title}</span>
                                                    </a>
                                                    )}
                                                </>
                                        </div>
                                        }

                                        </>
                                        }
                                        {accountSubscriptionType !== "trial" && accountSubscriptionPlan === "advanced" && 
                                             <>
                                             {accountStatus !== 'canceled' &&
                                             <>

                                                    <div style={{fontWeight:'bold', color:'blue',fontSize:'20px'}}>
                                                        Your Current Plan
                                                    </div>

                                                    {accountSubscriptionFrequency !== selectedFrequency &&
                                                    <div>
                                                    <>
                                                        {loadingPlanId === "advanced" ? (
                                                            <div
                                                                style={{
                                                                width: "24px",
                                                                height: "24px",
                                                                border: "3px solid #f3f3f3",
                                                                borderTop: "3px solid #3498db",
                                                                borderRadius: "50%",
                                                                animation: "spin 1s linear infinite",
                                                                display: "inline-block"
                                                                }}
                                                            />
                                                            ) : (
                                                            <a
                                                                className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                                onClick={() => goToCustomerPortal("advanced")}
                                                                style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                                >
                                                                <span>Switch to {accountSubscriptionFrequency=== "monthly" ? "Yearly" : "Monthly"}</span>
                                                            </a>
                                                            )}
                                                            
                                                    </>
                                                    </div>

                                                    
                                                    }

                                                 </>   
                                              }

                                              {accountStatus === 'canceled' && 
      
                                                <>
                                                    {loadingPlanId === "advanced" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("advanced")}
                                                        style={loadingPlanId === "advanced" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Renew to {PLANS.planAdditionaInfo['advanced'].title}</span>
                                                    </a>
                                                    )}
                                                </>
      
                                                }


                                            </>    
                                        }
            
                                        </span>
                                    }
            
                                    {!isUserLoggedIn && 
                                        
                                        <div class="pricePagegr-no-credit-card pricePagetext-center ">
                                        or <a href="#" onClick={(e) => {e.preventDefault(); handleSubscribe("advanced"); }} style={{ fontSize: "17px", fontWeight: "bold", textDecoration: "underline", color: "blue", cursor: "pointer" }}>
                                        Subscribe
                                        </a>
                                        <br/>
                                        <div style={{paddingTop:'5px'}}>
                                        7 day free trial<br></br>    
                                        No credit card required.
                                        </div>
                                        
                                        
                                        </div>
                                    }
                    </div>
                    <div class="pricePagepartnerTestWrap ">
                        <h6 class="pricePagefont300 pricePagegr-bottom-spaces-0 pricePagegr-top-spaces20 " style={{fontSize:'19px'}}>
                        What You Get
                        </h6>
                        <ul class="pricePagegr-spaces-0 ">
                          <li key={0} className="pricePageblueCheck" style={{fontSize:'17px'}}>
                            Up to <b>{plans.planAdditionaInfo['advanced'].maxUserAccounts}</b> {plans.planAdditionaInfo['advanced'].maxUserAccounts === 1 ? "seat" : "seats"}
                          </li>  
                        {plans.planAdditionaInfo['advanced'].features.map((feature, index) => (
                          <li key={index} className="pricePageblueCheck" style={{fontSize:'17px'}}>
                            {feature}
                          </li>
                        ))}
                        </ul>
                    </div>
                    </div>
                </div>

                {/* Fourth Plan  */}
                <div class="pricePagegr-pricing-sub-menu-item4 pricePagegr-pricing-sub-menuItemAll pricePagegr-tile-price-top-space ">
                    <div class="pricePagegr-most-popular-wrap pricePagegr-encloser-white pricePagegr-bottom-border-dark-purple pricePagegr-left-border ">
                    <h5 class="pricePagegr-most-popular pricePagegr-encloser-dark-purple pricePagewhite pricePagegr-spaces-0 pricePagefont400 " style={{fontSize:'20px'}}>
                        {PLANS.planAdditionaInfo['enterprise'].title}
                    </h5>
                    <div class="pricePagegr-enclose-top-item ">
                        
                         <div classX="pricePagetext-center pricePagegr-desktop-min-height " style={{fontSize:'17px', ...(window.innerWidth > 768 && { minHeight: '130px' })}}>
                        {PLANS.planAdditionaInfo['enterprise'].description}
                        </div>
                        <h4 class="pricePagecolorDarkPurpleX pricePagefont500 pricePagetext-center pricePagegr-bottom-spaces-0 pricePagegr-price-amount-top-space ">
                        <center>
                            <table>
                                <tr>
                                <td style={{fontSize:'45px',fontWeight:'bold'}}>{getPlanPriceIntegerPart('enterprise',frequency)}</td>
                                <td style={{padding:'0px',margin:'0px',paddingLeft:'5px'}}>
                                <div style={{paddingBottom:'-5px',marginBottom:'-5px',fontSize:'16px',fontWeight:'bold'}}>.{getPlanPriceDecimalPart('enterprise',frequency)}</div> <div style={{paddingBottom:'-15px',marginBottom:'-15px',fontSize:'16px'}}>monthly</div>
                                </td>
                                </tr>
                            </table>
                        </center>
                        </h4>
                        <div class="pricePagegr-substansive-value pricePagetext-center " style={{paddingTop:'6px'}}>
                        Cancel Anytime
                        {frequency != "monthly" &&  
                              <div style={{fontWeight:'plain',fontSize:'14px',color:'blue'}}>
                                Billed {frequency}
                                </div>
                            }
                        </div>
                        {!isUserLoggedIn && 
                                    
                                    <div class="pricePagegr-signup-button pricePagetext-center ">
                                        <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/signup"} style={{textDecoration:'none'}}><span>Try it for FREE</span></a>
                                    </div>
                                    
                                    }
            
            
                                    {isUserLoggedIn && 
                                        <span>
                                        {(accountSubscriptionType === "trial" || (accountSubscriptionType !== "trial" && accountSubscriptionPlan !== "enterprise")) && 
                                         <>
                                        {accountStatus !== 'canceled' &&
                                            <div>
                                             
                                                 {accountSubscriptionType === "trial" &&
                                                <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " onClick={(e) => {e.preventDefault(); handleSubscribe("enterprise"); }}><span>Subscribe to {PLANS.planAdditionaInfo['enterprise'].title}</span></a>
                                                }
                                                {(accountSubscriptionType !== "trial" && accountSubscriptionPlan !== "enterprise") &&
                                                 <>
                                                {loadingPlanId === "enterprise" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("enterprise")}
                                                        style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Switch to {PLANS.planAdditionaInfo['enterprise'].title}</span>
                                                    </a>
                                                    )}
                                                </>
                                                }  
                                            </div>

                                            }

                                            {accountStatus === 'canceled' &&
                                            <div>
                                                 <>
                                                {loadingPlanId === "enterprise" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("enterprise")}
                                                        style={loadingPlanId === "enterprise" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Renew to {PLANS.planAdditionaInfo['enterprise'].title}</span>
                                                    </a>
                                                    )}
                                                </>

                                            </div>
                                            }

                                            </>

                                        }
                                        {accountSubscriptionType !== "trial" && accountSubscriptionPlan === "enterprise" && 
                                               <>
                                                {accountStatus !== 'canceled' &&
                                                  <>  
                                                    <div style={{fontWeight:'bold', color:'blue',fontSize:'20px'}}>
                                                        Your Current Plan
                                                    </div>

                                                    {accountSubscriptionFrequency !== selectedFrequency &&
                                                    <div>
                                                    <>
                                                    {loadingPlanId === "enterprise" ? (
                                                        <div
                                                            style={{
                                                            width: "24px",
                                                            height: "24px",
                                                            border: "3px solid #f3f3f3",
                                                            borderTop: "3px solid #3498db",
                                                            borderRadius: "50%",
                                                            animation: "spin 1s linear infinite",
                                                            display: "inline-block"
                                                            }}
                                                        />
                                                        ) : (
                                                        <a
                                                            className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                            onClick={() => goToCustomerPortal("enterprise")}
                                                            style={loadingPlanId === "lite" ? { backgroundColor: "gray" } : undefined}
                                                            >
                                                            <span>Switch to {accountSubscriptionFrequency=== "monthly" ? "Yearly" : "Monthly"}</span>
                                                        </a>
                                                        )}
                                                    </>
                                                    </div>
                                                    }
                                                </>
                                              }

                                              {accountStatus === 'canceled' && 
      
                                                <>
                                                    {loadingPlanId === "enterprise" ? (
                                                    <div
                                                        style={{
                                                        width: "24px",
                                                        height: "24px",
                                                        border: "3px solid #f3f3f3",
                                                        borderTop: "3px solid #3498db",
                                                        borderRadius: "50%",
                                                        animation: "spin 1s linear infinite",
                                                        display: "inline-block"
                                                        }}
                                                    />
                                                    ) : (
                                                    <a
                                                        className="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a"
                                                        onClick={() => goToCustomerPortal("enterprise")}
                                                        style={loadingPlanId === "enterprise" ? { backgroundColor: "gray" } : undefined}
                                                        >
                                                        <span>Renew to {PLANS.planAdditionaInfo['enterprise'].title}</span>
                                                    </a>
                                                    )}
                                                </>
      
                                                }

                                            </>    
                                        }
            
                                        </span>
                                    }

                                    {!isUserLoggedIn && 
                                        
                                        <div class="pricePagegr-no-credit-card pricePagetext-center ">
                                        or <a href="#" onClick={(e) => {e.preventDefault(); handleSubscribe("enterprise"); }} style={{ fontSize: "17px", fontWeight: "bold", textDecoration: "underline", color: "blue", cursor: "pointer" }}>
                                        Subscribe
                                        </a>
                                        <br/>
                                        <div style={{paddingTop:'5px'}}>
                                        7 day free trial<br></br>    
                                        No credit card required.
                                        </div>
                                
                                        
                                        </div>
                                    }
                    </div>
                    <div class="pricePagepartnerTestWrap ">
                        <h6 class="pricePagefont300 pricePagegr-bottom-spaces-0 pricePagegr-top-spaces20 " style={{fontSize:'19px'}}>
                        What You Get
                        </h6>
                        <ul class="pricePagegr-spaces-0 ">
                          <li key={0} className="pricePageblueCheck" style={{fontSize:'17px'}}>
                            Up to <b>{plans.planAdditionaInfo['enterprise'].maxUserAccounts}</b> {plans.planAdditionaInfo['enterprise'].maxUserAccounts === 1 ? "seat" : "seats"}
                          </li>  
                        {plans.planAdditionaInfo['enterprise'].features.map((feature, index) => (
                          <li key={index} className="pricePageblueCheck" style={{fontSize:'17px'}}>
                            {feature}
                          </li>
                        ))}
                        </ul>
                    </div>
                    </div>
                </div>

                </div>
            </div>
            </div> 
            <div class="pricePagegr-special-pricing-submenu-enclosureBox pricePagegr-top-spaces40 " style={{backgroundColor:'#583bec',width:'100%'}}>
            <div class="pricePagegr-special-pricing-submenu-enclosure ">
                <div class="pricePagegr-enclose-top-item pricePagegr-space-fix ">
                <div class="pricePagecolItemAll pricePagecolItem1 ">
                    <h5 class="pricePagecolorBlueLight pricePagefont500 pricePagewhite pricePagegr-top-spaces0 pricePagegr-bottom-spaces-a " style={{color:'#ffffff', fontSize:'19px'}}>
                    Custom Pricing
                    </h5>
                    <div class="pricePagewhite " style={{fontSize:'17px'}}>
                    We provide customized plans to fit your specific needs specifically for bigger companies that require more logins.
                    </div>
                </div>
        
                <div class="pricePagecolItemAll pricePagecolItem5 ">
                    <div class="pricePagegr-signup-button pricePagetext-center ">
                    <a class="pricePagebtn pricePagenormal pricePagegr-gtitem-light-blue pricePagegr-spaces-a " href="/contactus" style={{backgroundColor:'#ffffff',fontWeight:'bold', textDecoration:'none'}}><span>CONTACT SALES</span></a>
                    </div>
                </div>
                </div>
            </div>
            </div>
            <div class="pricePagegr-top-spaces40 pricePagedetailsDecide " id="openPrincigDetails" style={{width:'100%'}}>
            <h4 class="pricePagegr-top-spaces0 pricePagetext-center " style={{fontSize:'24px', paddingBottom: '0px', marginBottom: '0px'}}>
                Can't decide which plan is right for you?
            </h4>
            <div class="pricePagecomparationBox pricePagegr-space-fix " style={{paddingTop: '0px', marginTop: '0px'}}>

                <div class="pricePagegr-comparing-plans pricePagegr-future-left-side " style={{paddingTop: '0px', marginTop: '0px', paddingBottom: '0px', marginBottom: '0px'}}>

                <div class="pricePagegr-future-title " style={{fontSize:'17px', textAlign:'center',paddingTop: '10px', marginTop: '0px'}}>
                    No worries, you can change your plan any time without skipping a beat.
                </div>
                
                </div>

            </div>
            </div>
        </div>
        </div>
        </div>
        {/* END Section1  */}

        {/* START Section2  */}
        <div class="pricePagesection3 pricePagegr-encloser-gray pricePagegr-container1 ">
        <div class="pricePagecontainer pricePageignore-additional-spaces ">
        <div class="pricePagerow pricePageignore-additional-spaces ">
            <div class="pricePagegr-informational-client-whiteWrap " style={{width:'100%'}}>
            <div class="pricePagegr-informational-client-white-enclosure pricePagegr-space-fix ">
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-whiteTitle ">
                Included in All Plans:
                </div>
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Growth Metrics" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/growth-metrics.png' /></span> <span class="pricePagegr-our-care-text ">Growth
                <br />
                Metrics </span>
                </div>
                {/*
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Advanced Searches" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/magnified-operations-view.png' /></span> <span class="pricePagegr-our-care-text ">Magnified
                <br />
                View</span>
                </div>
                */}
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Reporting and Analytics" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/smart-monitoring.png' /></span> <span class="pricePagegr-our-care-text ">Smart &amp;
                <br />
                Monitoring</span>
                </div>
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Multiple Profiles" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/user-management.png' /></span> <span class="pricePagegr-our-care-text ">User
                <br />
                Management</span>
                </div>
                <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagegr-informational-client-white ">
                <span class="pricePagegr-our-care-image "><img alt="Financial Indicators" border="0" class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/financial-monitoring.png' /></span> <span class="pricePagegr-our-care-text ">Financial
                <br />
                Monitoring</span>
                </div>
            </div>
            </div>
        </div>
        </div>
        </div>
        
        {/* END Section3  */}
        
        {/* START Section4  */}
        <div class="pricePagegr-space-fix pricePagesection4 pricePagegr-encloser-blue ">
        <div class="pricePagecontainer pricePageignore-additional-spaces ">
        <div class="pricePagerow pricePageignore-additional-spaces ">
            <h4 class="pricePagewhite pricePagetext-center pricePagegr-spaces-b " style={{textAlign:'center',width:'100%'}}>
            <div style= {{fontSize:'25px',fontWeight:'bold'}}>100% RISK FREE</div>
            This is why so many people and organizations trust us
            </h4>
                <div class="pricePagegr-informational-client-whiteWrap ">
                    <div class="pricePagegr-informational-client-white-enclosure pricePagegr-space-fix pricePagegr-multiple-sections-5-enclosure ">
                        <div class="pricePagecol-md-2 pricePagegr-spaces-a pricePagewhite pricePagegr-informational-client-whiteTitle ">
                            Trusted by professionals, businesses, and organizations across industries.
                        </div>
            
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                            <a class="pricePagegr-icon-effect " href="/pricing">
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/free-trial.png' alt="Free trial" border="0" style={{width:'135px',height:'119px'}}/>
                            </a>
                        </div>
                    
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                            
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/money-back-guarantee.png' alt="Money back guarantee" border="0"/>
                           
                        </div>
                        {/* 
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                           
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/cancel-any-time.png' alt="Cancel anytime" border="0" style={{width:'200px',height:'131px'}}/>
                           
                        </div>
                        */}
                    
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                          
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/satisfaction-gurantee.png' alt="satisfaction gurantee" border="0" style={{width:'125px',height:'108px'}}/>
                           
                        </div>
                    
                        <div class="pricePagecol-md-2 pricePagegr-spaces-b pricePagegr-informational-client-white ">
                            
                                <img class="pricePagegr-image-responsive pricePagecenter-block " src='https://gotailo.com/images/secured-ssl.png' alt="Secured SSL" border="0" />
                            
                        </div>
                    
                    </div>
                </div>
        </div>
        </div>
        </div>
        
        {/* END Section4  */}
        
             </div>
    }

        </div>
                {/* Stop Loading Content  */}

                {/* Start Loading Bottom Blocks  */}
                <div class="pricePagegr-enclose-g-container pricePagegr-enclosed-rotate-wrap ">
                <div class="pricePagegr-enclosed-rotate ">
                    <div class="pricePagecontainer pricePageignore-additional-spaces ">
                        <div class="pricePagerow pricePagegr-space-fix ">
                            <div class="pricePagecol-md-8 pricePagegr-footer-left pricePagetextX pricePageignore-additional-spaces ">
                                <div>
                                    <div class="pricePagegr-start-text-enclosure pricePagetext-center ">
                                        <h5 class="white gr-spaces-0"  style={{color:'#FFFFFF',fontSize:'18px'}}>
                                            Transform how you tailor with us. Try GoTailo<sup style={{fontSize:'12px'}}>&#174;</sup>.
                                        </h5>
                                        <div class="white" style={{color:'#FFFFFF',fontSize:'18px'}}>
                                            The only platform integrating services to enhance performances and amplify customer satisfaction.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pricePagecol-md-4 pricePagegr-footer-right pricePageignore-additional-spaces ">
                                <div>
                                    <div class="pricePagegr-start-button-enclosure pricePagetext-center ">
                                        <a class="pricePagebtn pricePagenormal pricePagegr-gtitem-white " href="/login">LOGIN</a>
                                        <a class="pricePagebtn pricePagenormal pricePagegreen " href="/signup">SIGN UP for FREE</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                
                {/* Stop Loading Bottom Blocks  */}
            </div>
            {/* Stop Content  */}

                    {/* Start Template Footer  */}
                    <footer class="pricePagev2 ">
                    <div class="pricePagefooter ">
                        <div class="">
                            <div class="pricePagerow ">
                                <div class="pricePagecontainer pricePageignore-additional-spaces ">
                                    <div class="pricePagegr-footer-wrap " style={{width:'100%'}}>
                                        <div class="pricePagegr-footer-top-wrap pricePagegr-space-fix ">
                                            <div class="pricePagegr-footer-top pricePagegr-space-fix ">
                                                <div class="pricePagecolAll pricePagecol1 ">
                                                    <ul class="pricePagegr-footer-enclose-wrap pricePagefooterNav ">
                                                        <li class="pricePagegr-footer-enclose-logo-wrap ">
                                                            <a class="pricePagegr-footer-enclose-logo " href="/">
                                                                <img class="pricePagelogo "style={{width:'55px'}} src='https://gotailo.com/images/logo.png' alt="Saas application" border="0"/>
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-title pricePagegr-footer-enclose-1 ">
                                                            <h5 class="pricePagegr-top-spaces10 pricePagegr-bottom-spaces-0 ">
                                                                Tailor management. Simplified.
                                                            </h5>
                                                        </li>
                                                        {/* 
                                                        <li class="pricePagegr-social-box pricePagegr-space-fix pricePagegr-bottom-spaces-b ">
                                                            <ul class="pricePagesocial pricePagegr-space-fix ">
                                                                <li>
                                                                    <a class="pricePagegr-footer-flickr " href="https://www.instagram.com/gorepa.analytics/"  target="_blank">
                                                                        <img alt="instagram" border="0" class="pricePagegr-social-image pricePagegr-social-imageDark " src='https://gotailo.com/images/instagram-footer-white.png'/>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a class="pricePagegr-footer-linkedin " href="https://www.linkedin.com/company/gorepa/"  target="_blank">
                                                                        <img alt="linkedin" border="0" class="pricePagegr-social-image pricePagegr-social-imageDark " src='https://gotailo.com/images/linkedin-footer-white.png'/>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a class="pricePagegr-footer-twitter " href="https://www.twitter.com/GoTailoAnalytics"  target="_blank">
                                                                        <img alt="twitter" border="0" class="pricePagegr-social-image pricePagegr-social-imageDark " src='https://gotailo.com/images/twitter-footer-white.png'/>
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a class="pricePagegr-footer-facebook " href="https://www.facebook.com/GoTailoAnalytics"  target="_blank">
                                                                        <img alt="facebook" border="0" class="pricePagegr-social-image pricePagegr-social-imageDark " src='https://gotailo.com/images/facebook-footer-white.png'/>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        */}
                                                    </ul>
                                                </div>
                                        
                                                <div class="pricePagecolAll pricePagecol4 ">
                                                    <ul class="pricePagefooterNav ">
                                                        <li class="pricePagegr-footer-enclose-1 ">
                                                            <a class="pricePagemenuNoLink " href="/about.html">
                                                                COMPANY
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/about.html">
                                                                About Us
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="pricePagecolAll pricePagecol5 ">
                                                    <ul class="pricePagefooterNav pricePagegr-second-level ">
                                                        <li class="pricePagegr-footer-enclose-1 ">
                                                            <a class="pricePagemenuNoLink " href="/faq.html">
                                                                RESOURCES
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/faq.html">
                                                                FAQ
                                                            </a>
                                                        </li>
                                               
                                                    </ul>
                                                </div>
                                                <div class="pricePagecolAll pricePagecol6 ">
                                                    <ul class="pricePagefooterNav ">
                                                        <li class="pricePagegr-footer-enclose-1 ">
                                                            <a class="pricePagemenuNoLink "  href="/contactus">
                                                                CONTACT US
                                                            </a>
                                                        </li>
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/login">
                                                                Login
                                                            </a>
                                                        </li>
                                                  
                                                        <li class="pricePagegr-footer-enclose-2 ">
                                                            <a href="/contactus">
                                                                Contact Us
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pricePagegr-footer-bottom-wrap ">
                                            <ul class="pricePagegr-space-fix ">
                                                <li class="pricePagegr-footer-enclose-policy pricePagegr-space-fix ">
                                                    <a href="/privacy.html">
                                                        Privacy Policy
                                                    </a>
                                                    <a href="/terms-of-service.html" >
                                                        Terms and Conditions
                                                    </a>
                                                    <a href="refund-policy.html" >
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Refund Policy
                                                    </a>
                                                </li>
                                                <li class="pricePagegr-footer-copyright ">
                                                    &#169; 2025 Copyright GoTailo<sup style={{fontsize:'12px'}}>&#174;</sup>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            


                </div>

)}    

<div>
    
</div>
  {accountSubscriptionType === "paid" && (

             <div class="pricePagegr-signup-button pricePagetext-center ">
                            <a class="pricePagebtn pricePagenormal pricePageblue pricePagegr-spaces-a " href={"/app"} style={{textDecoration:'none'}}><span>Take Me to the Application</span></a>
             </div>

 
            )}

            <Dialog open={openAdminOnlyDialog} onClose={() => setOpenAdminOnlyDialog(false)}>
                <DialogTitle>Administrator Only Action</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    <p>
                  Only administrators can manage subscriptions.
                  </p>
                  <p>
                  Please contact your organization’s admin to perform this action.
                  </p>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button  onClick={() => setOpenAdminOnlyDialog(false)} sx={{fontSize:'18px', fontWeight:'bold', border: "1px solid #8a8a8a", borderRadius: "12px", backgroundColor:'#f1f1f1'}} autoFocus>
                    OK
                  </Button>
                </DialogActions>
              </Dialog>


        <script type="text/javascript" src="js/jquery.colorbox-min.js"></script>
        
</body>

</html>
  );
};

const ShadowPage = () => {
  return <PricingShadowWrapper><ShadowPageContent /></PricingShadowWrapper>;
};

export default ShadowPage;
